import type { Routes } from '@angular/router';
import { secureRoute } from './core/utils/transformers';
import { UserCreateComponent } from './features/users/pages/user-create/user-create';
import { UserDetailsComponent } from './features/users/pages/user-details/user-details';
import { UserEditComponent } from './features/users/pages/user-edit/user-edit';
import { UsersViewComponent } from './features/users/pages/users-view/users-view';

export const userRoutes: Routes = [
  secureRoute({
    path: 'users',
    component: UsersViewComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'użytkownicy',
          isCurrent: true,
          url: '/users',
        },
      ],
    },
  }),
  secureRoute({
    path: 'users/:id/details',
    component: UserDetailsComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'użytkownicy',
          isCurrent: false,
          url: '/users',
        },
        {
          id: 1,
          label: 'detale',
          isCurrent: true,
          url: '/users/:id/details',
        },
      ],
    },
  }),
  secureRoute({
    path: 'users/create',
    component: UserCreateComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'użytkownicy',
          isCurrent: false,
          url: '/users',
        },
        {
          id: 1,
          label: 'tworzenie',
          isCurrent: true,
          url: '/users/create',
        },
      ],
    },
  }),
  secureRoute({
    path: 'users/:id/edit',
    component: UserEditComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'użytkownicy',
          isCurrent: false,
          url: '/users',
        },
        {
          id: 1,
          label: 'edycja',
          isCurrent: true,
          url: '/users/:id/edit',
        },
      ],
    },
  }),
];
